import { render, staticRenderFns } from "./permission-tooltip.vue?vue&type=template&id=19c95910&scoped=true"
import script from "./permission-tooltip.vue?vue&type=script&lang=js"
export * from "./permission-tooltip.vue?vue&type=script&lang=js"
import style0 from "./permission-tooltip.vue?vue&type=style&index=0&id=19c95910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c95910",
  null
  
)

export default component.exports